export const IGNORED_ERRORS = [
  'Tried to emit action [update], but WebSocket not open',
  'ResizeObserver loop limit exceeded',
  'AbortError: The user aborted a request.',
  'SecurityError: Blocked a frame with origin "https://app.savvywealth.com" from accessing a cross-origin frame. Protocols, domains, and ports must match.',
];
